{
  "name": "@ciraconnect/ciranet-resident-ui",
  "version": "26.7.4.2",
  "description": "CiraNet Resident UI",
  "author": "CiraConnect",
  "engines": {
    "node": ">=22.17.0",
    "npm": ">=10.9.2 <11"
  },
  "private": true,
  "scripts": {
    "ng": "node --max-old-space-size=5120 ./node_modules/@angular/cli/bin/ng",
    "postinstall": "patch-package && node scripts/generate-devextreme-license.js",
    "prepare": "husky",
    "prebuild": "npm run format && npm run lint",
    "build": "npm run ng build",
    "build:prod": "npm run ng -- build -c prod",
    "build:local-prod": "npm run ng -- build -c local-prod",
    "build:local-qa": "npm run ng -- build -c local-qa",
    "build:local-demo": "npm run ng -- build -c local-demo",
    "build:local-dev": "npm run ng -- build -c local-dev",
    "prebuild:local": "node scripts/generate-local-flags.js",
    "prebuild:local-dev": "node scripts/generate-local-flags.js",
    "prebuild:local-qa": "node scripts/generate-local-flags.js",
    "prebuild:local-demo": "node scripts/generate-local-flags.js",
    "prebuild:local-prod": "node scripts/generate-local-flags.js",
    "build:local": "npm run ng -- build -c local",
    "prestart:local": "node scripts/generate-local-flags.js",
    "prestart:local-dev": "node scripts/generate-local-flags.js",
    "prestart:local-qa": "node scripts/generate-local-flags.js",
    "prestart:local-demo": "node scripts/generate-local-flags.js",
    "prestart:local-prod": "node scripts/generate-local-flags.js",
    "start": "npm run ng serve",
    "start:prod": "npm run ng -- serve -c prod",
    "start:local-prod": "npm run ng -- serve -c local-prod",
    "start:local-qa": "npm run ng -- serve -c local-qa",
    "start:local-demo": "npm run ng -- serve -c local-demo",
    "start:local-dev": "npm run ng -- serve -c local-dev",
    "start:local": "npm run ng -- serve -c local",
    "format:check": "prettier --check \"src/**/*.{ts,scss,html,json}\"",
    "format": "prettier --write \"src/**/*.{ts,scss,html,json}\"",
    "lint:check": "npm run ng lint",
    "lint": "npm run ng -- lint --fix",
    "lint:scss": "stylelint \"src/**/*.scss\" --fix",
    "lint:scss:check": "stylelint \"src/**/*.scss\"",
    "sonar": "sonar-scanner -Dsonar.host.url=https://sonarqube.ciranet.com -Dsonar.login=6cd92a3edce871db2936e7428ac81920b7ced2ae -Dsonar.sources=src/app -Dsonar.projectKey=ResidentPortal-UI",
    "watch": "npm run ng -- build --watch"
  },
  "dependencies": {
    "@angular-architects/native-federation": "^21.2.3",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.0.0",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@auth0/angular-jwt": "^5.2.0",
    "@ciranet/ui": "^1.13.0",
    "@datadog/browser-rum": "^6.18.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@therealmanage/ciranet-ui-common": "^1.1.7",
    "@types/grecaptcha": "^3.0.9",
    "angular-split": "^19.0.0",
    "class-transformer": "^0.5.1",
    "crypto-js": "^4.2.0",
    "devextreme": "~24.2.8",
    "devextreme-angular": "~24.2.8",
    "file-saver": "^2.0.5",
    "luxon": "^3.5.0",
    "moment-timezone": "^0.5.47",
    "ng-recaptcha-2": "^15.0.3",
    "ngx-cookie-service": "^19.1.2",
    "ngx-device-detector": "^9.0.0",
    "ngx-image-cropper": "^7.2.1",
    "ngx-webcam": "^0.4.1",
    "postscribe": "^2.0.8",
    "reflect-metadata": "^0.2.2",
    "rrule": "^2.8.1",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.13",
    "@angular-devkit/core": "^19.2.15",
    "@angular-devkit/schematics": "^19.2.15",
    "@angular-eslint/builder": "^18.0.0",
    "@angular-eslint/eslint-plugin": "^18.0.0",
    "@angular-eslint/eslint-plugin-template": "^18.0.0",
    "@angular-eslint/template-parser": "^18.0.0",
    "@angular/build": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@typescript-eslint/eslint-plugin": "^8.22.0",
    "@typescript-eslint/parser": "^8.22.0",
    "@typescript-eslint/types": "^8.22.0",
    "@typescript-eslint/utils": "^8.22.0",
    "baseline-browser-mapping": "^2.9.18",
    "eslint": "^9.19.0",
    "husky": "^9.1.7",
    "lint-staged": "^15.2.10",
    "patch-package": "^8.0.0",
    "prettier": "^3.4.2",
    "sonarqube-scanner": "^4.2.6",
    "stylelint": "^16.12.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "typescript": "~5.8.3"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "eslint --fix --cache",
      "prettier --write"
    ],
    "src/**/*.scss": [
      "stylelint --fix",
      "prettier --write"
    ],
    "src/**/*.json": [
      "prettier --write"
    ]
  }
}
